import styled from 'styled-components'

export const TopBarStyledContainer = styled.g`
    &,
    * {
        transition: none !important;
    }
`

export const TopEventText = styled.tspan`
    fill: #000 !important;
    color: ${({ theme }) => theme['gray-100']};
`

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 18px;
    font-size: 18px;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${({ theme }) => theme['font-regular']};
    text-align: center;
    font-weight: 600;
    color: #000;
    max-width: 100%;
    max-height: 100%;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    &.bowtie-code {
        font-size: 14px;
    }
`
